import { createContext } from "react";
const AppointmentContext = createContext();
export default AppointmentContext;
